import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const AdminLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.post(`${BACKEND_URL}/api/auth/login`, {
        username,
        password,
      });

      localStorage.setItem('edx_admin_token', response.data.access_token);
      toast.success('Login successful!');
      navigate('/edx-control-panel');
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Invalid credentials');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[hsl(210,40%,98%)] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8" data-testid="admin-login-page">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-lg shadow-xl p-8">
          {/* Logo */}
          <div className="text-center mb-8">
            <div className="inline-flex items-center space-x-3 mb-4">
              <div className="w-16 h-16 bg-[hsl(215,75%,16%)] rounded-md flex items-center justify-center">
                <span className="text-white font-bold text-2xl">EDX</span>
              </div>
            </div>
            <h2
              className="text-3xl font-bold text-[hsl(215,75%,16%)]" style={{ fontFamily: 'Outfit' }}
            >
              Admin Login
            </h2>
            <p className="text-gray-600 mt-2">EDX Control Panel</p>
          </div>

          {/* Login Form */}
          <form onSubmit={handleSubmit} className="space-y-6" data-testid="admin-login-form">
            <div>
              <Label htmlFor="username" className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
                Username
              </Label>
              <Input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                className="mt-2 border-gray-300 focus:border-[hsl(224,64%,33%)] focus:ring-2 focus:ring-[hsl(224,64%,33%)]/20"
                placeholder="Enter username"
                data-testid="admin-login-username"
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
                Password
              </Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-2 border-gray-300 focus:border-[hsl(224,64%,33%)] focus:ring-2 focus:ring-[hsl(224,64%,33%)]/20"
                placeholder="Enter password"
                data-testid="admin-login-password"
              />
            </div>

            <Button
              type="submit"
              disabled={isLoading}
              className="w-full bg-[hsl(215,75%,16%)] text-white hover:bg-[hsl(224,64%,33%)] py-6 rounded-md font-semibold text-base"
              data-testid="admin-login-submit"
            >
              {isLoading ? 'Logging in...' : 'Login'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};